import type { StoreProfileDetail } from '../types';
import { SUPERVALU_RATHMINES } from './supervalu-rathmines';

/**
 * Demo profiles are reachable only via their explicit slug and render with Demo
 * provenance labels. Live stores never receive demo content — live and demo data
 * are never silently blended.
 */
const DEMO_PROFILES_BY_SLUG: Record<string, StoreProfileDetail> = {
  [SUPERVALU_RATHMINES.id]: SUPERVALU_RATHMINES,
};

export function getDemoProfileBySlug(slug: string): StoreProfileDetail | undefined {
  return DEMO_PROFILES_BY_SLUG[slug];
}

/**
 * Live stores never receive a demo scaffold. Kept as a named seam so callers make
 * the live/demo decision explicitly — always returns undefined for live stores.
 */
export function getProfileScaffold(_input?: {
  storeId?: number;
  storeName?: string;
  retailerName?: string;
}): StoreProfileDetail | undefined {
  return undefined;
}
